
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "parts/Navbars/DefaultNavbar";
import DefaultFooter from "parts/Footers/DefaultFooter";

// About Us page sections
import Information from "pages/landing-pages/digital-marketing/sections/Information";
import Team from "pages/landing-pages/digital-marketing/sections/Team";
import Featuring from "pages/landing-pages/digital-marketing/sections/Featuring";
import Newsletter from "pages/landing-pages/digital-marketing/sections/Newsletter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/contact.jpg";
import { Helmet } from 'react-helmet';

function DIGMAR() {
  return (
    <>
        <Helmet>
        <title>Digital Marketing Services - HPTech Solutions</title>
        <meta name="description" content="Boost your online presence with HPTech Solutions' Digital Marketing services. We specialize in SEO, SEM, social media marketing, and content creation to grow your brand." />
        <meta name="keywords" content="digital marketing, SEO, SEM, social media marketing, content marketing, HPTech Solutions" />
        <meta property="og:title" content="Digital Marketing Services - HPTech Solutions" />
        <meta property="og:description" content="HPTech Solutions provides digital marketing strategies that drive traffic, improve brand visibility, and increase conversions across multiple online platforms." />
        <meta property="og:image" content={bgImage} />
    </Helmet>
            <MKBox position="fixed" top="0.5rem" width="100%" zIndex="3">
        <DefaultNavbar
          routes={routes}
        />
      </MKBox>
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Digital Marketing
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
            Maximize Your Online Presence and Drive Business Growth</MKTypography>
            
            <MKTypography variant="h6" color="white" mt={8} mb={1}>
            Our Digital Marketing Process Includes
            </MKTypography>
            <MKBox display="flex" justifyContent="center" alignItems="center">
            <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
              <i className="fab fa-facebook" />
            </MKTypography>
            <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
              <i className="fab fa-instagram" />
            </MKTypography>
            <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
              <i className="fab fa-twitter" />
            </MKTypography>
            <MKTypography component="a" variant="body1" color="white" href="#">
              <i className="fab fa-google-plus" />
            </MKTypography>
          </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
          zIndex: 1,
        }}
      >
        <Information />
        <Team />
        <Featuring />
        <Newsletter />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default DIGMAR;
